import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OverlayPanelService {
  // Subject that will emit when overlay panels should be closed
  private readonly closeAllOverlays = new Subject<void>();

  // Observable that components can subscribe to
  closeAllOverlays$ = this.closeAllOverlays.asObservable();

  // Method to trigger closing all overlay panels
  closeAll() {
    this.closeAllOverlays.next();
  }
}
